import { api } from '../../lib/api';

/**
 * Listening activity: what you are hearing, told to the server while it
 * plays, and what your friends are hearing, read back. Friends are mutual
 * follows; the server decides who sees whom.
 */

export type ListeningContext =
  | { kind: 'track' }
  | { kind: 'collection'; id: number; label: string }
  | { kind: 'room'; username: string; label: string }
  | { kind: 'jam'; code: string; label: string };

export interface Activity {
  user: { username: string; display_name: string; verified: boolean; avatar: string | null };
  track: {
    id: number;
    title: string;
    artwork_small: string | null;
    owner: { username: string; display_name: string };
  };
  context: ListeningContext;
  /** Heard within the last couple of minutes: they are hearing it as you read this. */
  now: boolean;
  heard_at: string;
  started_at: string;
}

export interface Feed {
  items: Activity[];
  mine: Activity | null;
  /** Whether your own listening is being written right now (the setting, and no private session). */
  sharing: boolean;
}

/** What the player sends: where the track is being heard from. */
export type HeardContext =
  | { kind: 'track' }
  | { kind: 'collection'; id: number; label: string }
  | { kind: 'room'; username: string }
  | { kind: 'jam' };

export const activity = {
  feed: () => api.get<Feed>('/listening/friends'),
  heard: (trackId: number, context: HeardContext) =>
    api.post<{ heard: boolean; sharing: boolean }>('/me/listening', { track_id: trackId, context }, { keepalive: true }),
  stopped: () => api.delete('/me/listening', { keepalive: true }),
  /** A private session for `seconds`, or null to end one early. */
  privately: (seconds: number | null) => api.post<{ sharing: boolean }>('/me/listening/private', { seconds }),
};

export const FEED_KEY = ['listening', 'friends'];
